import React, { useEffect, useState } from 'react';
import classes from "./DailyPackExpired.module.css";
import Header from '../components/Header';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from "react-icons/fa6";
import { useLocation, useNavigate } from 'react-router-dom';
import SubLayout from '../components/SubLayout';
import AutoRenewalModal from '../components/AutoRenewalModal';
import { increaseValidityApi, login } from '../http/http';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { setUserDetails, setUserToken } from '../store/slices/userTokenSlice';
import SmallLoader from '../components/Loaders/SmallLoader';

const DailyPackExpired = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [autoRenewalModal, setAutoRenewalModal] = useState(false);
    // const [autoRenewal, setAutoRenewal] = useState(false);
    const [autoRenewal, setAutoRenewal] = useState(true);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const [msisdn, setMsisdn] = useState("");

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
        }
        else {
            navigate("/login");
        }
    }, [location]);

    console.log(msisdn,'msisdn...');

    const toggleAutoRenewal = () => {
        setAutoRenewal(!autoRenewalModal);
    }

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const response = await increaseValidityApi(msisdn, uuidv4(), autoRenewal ? "renewal" : "ondemand");
            // setLoading(false);

            if (response?.data?.status == 4) {
                toast.success(t("90"));
            }

            if (response?.data?.status == 3) {
                setLoading(false);
                toast.success(t("91"));
                navigate("/low-balance");
                return;
            }

            await login({ msisdn:msisdn })
                .then((res) => {
                    setLoading(false);
                    dispatch(setUserToken(res?.data?.result?.token));
                    dispatch(setUserDetails(res?.data?.result));
                    navigate("/home", { replace: true, state: null });
                    toast.success(t("84"));
                })
                .catch((err) => {
                    setLoading(false);
                    toast.error(t("92"));
                });

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);
            if (error?.response?.data?.status == 0) {
                toast.error(t("93"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error(t("94"));
            }
            else if (error?.response?.data?.status == 2) {
                toast.error(t("103"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    return (
        <>
            <Header />
            {/* <div className={classes.container}> */}
            <SubLayout style={{ justifyContent: "center", alignItems: "center" }}>


                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                </div>


                <div className={classes.info}>
                    <img
                        src="/assets/images/info.png"
                        alt="info"
                        className={classes.img}
                    />
                </div>
                <div className={classes.text_container}>
                    <p className={classes.text}>
                        {t("119")}
                    </p>
                    <p className={classes.text}>
                        {t("120")}
                    </p>

                    <div className={classes.auto_renewal_container}>
                        <input type="checkbox" id="autoRenewal" name="Auto Renewal" value="Auto Renewal"
                            className={classes.check_box} checked={autoRenewal} onClick={toggleAutoRenewal}
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            <span className={classes.link} onClick={() => setAutoRenewalModal(true)}>{t("101")}</span>
                        </label>
                    </div>

                    <div className={classes.btns_container}>
                        <button className={classes.btn} type="button"
                            disabled={loading}
                            onClick={handleSubmit}
                        >
                            {loading ? <SmallLoader /> :
                                t("80")
                            }
                        </button>
                        <button
                            className={classes.btn_2}
                            type="button"
                            disabled={loading}
                            onClick={() => navigate("/login")}
                        >
                            {t("81")}
                        </button>
                    </div>

                </div>
            </SubLayout>

            {autoRenewalModal && <AutoRenewalModal setModal={setAutoRenewalModal} />}

            {/* </div> */}
        </>
    )
}

export default DailyPackExpired